/** Цвета направляющих осей X/Y/Z (сцена и тулбар). */
export const GUIDING_AXIS_COLORS = Object.freeze({
    x: "#c62828",
    y: "#2e7d32",
    z: "#1565c0",
});
